import React, {useState, useEffect} from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import ApiService from '../util/ApiService';
import {Form} from 'react-bootstrap';
import Swal from 'sweetalert2';
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import "./assets/css/AccreditationComments.css";
import dayjs from "dayjs";
import "dayjs/locale/pt-br";
import {Avatar, Tag} from "antd";
import CustomPagination from "../util/CustomPagination";
import AuthService from "../login/AuthService"; // Importa o idioma PT-BR
const AccreditationCommentsModal = ({show, onHide, user = {}}) => {
    const userData = AuthService.getUserData();
    const [loadingSave, setLoadingSave] = useState(false);
    const [formData, setFormData] = useState({
        comment: '',
        user_interested: ''
    });

    useEffect(() => {
        if (user) {
                setFormData({
                comment: '',
                user_interested: user?.user_info?.id || user?.id
                });
        } else {
            setFormData({
                comment: '',
                user_interested: ''
            });
        }
    }, [user]);

    const handleSave = async () => {
        setLoadingSave(true);
        try {
            const response = await ApiService.send(
                'put',
                `${process.env.REACT_APP_URL_API}documents/updatecomment`,
                formData,
                true
            );

            if (response?.code === 200) {
                Swal.fire({
                    title: "Sucesso!",
                    text: "Atualizado com sucesso a avaliação",
                    icon: "success",
                    confirmButtonText: "OK",
                }).then(() => {
                    onHide(true);
                });
            } else {
                throw new Error(response?.data?.message || 'Erro ao salvar resposta.');
            }
        } catch (error) {
            ApiService.handleApiError(error);
        } finally {
            setLoadingSave(false);
        }
    };



    return (
        <Modal show={show} onHide={onHide} centered size="xl">
            <Modal.Header closeButton>
                <Modal.Title>Todas as Avaliações do Usuário</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="contact-details">
                    <h6 className="mb-2">Avaliações:</h6>
                    <div
                        style={{
                            maxHeight: "200px",
                            overflowY: "auto",
                            marginBottom: "15px",
                            border: "1px solid #ddd",
                            padding: "10px",
                            borderRadius: "5px",
                            backgroundColor: "#f7f7f7",
                        }}
                    >
                        {user?.history?.length > 0 ? (
                            <div className="chat-container">
                                {user.history.map((msg, index) => {
                                    const isOwnMessage = msg.logged_in_user?.id === userData.id;

                                    return (
                                        <div
                                            key={msg.event_id_origin}
                                            style={{
                                                display: "flex",
                                                flexDirection: "column",
                                                alignItems: isOwnMessage ? "flex-end" : "flex-start",
                                                marginBottom: "10px",
                                            }}
                                        >
                                            <div
                                                style={{
                                                    backgroundColor: isOwnMessage ? "#0084ff" : "#e4e6eb",
                                                    color: isOwnMessage ? "#fff" : "#000",
                                                    padding: "8px 12px",
                                                    borderRadius: isOwnMessage
                                                        ? "15px 15px 0 15px"
                                                        : "15px 15px 15px 0",
                                                    maxWidth: "75%",
                                                    wordBreak: "break-word",
                                                    fontSize: "14px",
                                                }}
                                            >
                                                <strong
                                                    style={{
                                                        fontSize: "12px",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        marginBottom: "5px",
                                                    }}
                                                >
                                                    <Avatar
                                                        src={msg.logged_in_user?.profile_image || process.env.REACT_APP_URL_STORAGE + "src/perfil_icone.png"}
                                                        size={20}
                                                        className="me-2"
                                                    />
                                                    {msg.logged_in_user?.name || "Anônimo"}
                                                </strong>
                                                <span dangerouslySetInnerHTML={{__html: msg.comment}} />
                                            </div>
                                            <small
                                                className="text-muted"
                                                style={{
                                                    fontSize: "11px",
                                                    marginTop: "2px",
                                                    paddingLeft: isOwnMessage ? "0" : "5px",
                                                    paddingRight: isOwnMessage ? "5px" : "0",
                                                }}
                                            >
                                                {msg.event_date
                                                    ? dayjs(msg.event_date).format("DD/MM/YYYY HH:mm")
                                                    : "Data não disponível"}
                                            </small>
                                        </div>
                                    );
                                })}





                            </div>
                        ) : (
                            <div className="alert alert-primary text-center" role="alert">
                                Nenhuma mensagem disponível.
                            </div>
                        )}
                    </div>


                    <h6>Avaliar:</h6>
                    <ReactQuill
                        theme="snow"
                        value={formData.comment || ""}
                        onChange={(content) => setFormData({...formData, comment: content})}
                        placeholder="Digite aqui..."
                        className="custom-quill mb-3"
                        modules={{
                            toolbar: [
                                [{header: [1, 2, false]}],
                                ["bold", "italic", "underline"],
                                [{list: "ordered"}, {list: "bullet"}],
                                ["link"],
                                ["clean"]
                            ],
                        }}
                        formats={[
                            "header", "bold", "italic", "underline",
                            "list", "bullet", "link", "image"
                        ]}
                    />
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={() =>onHide()}>
                    <i className="fa fa-close me-1"></i> Cancelar
                </Button>
                <Button variant="primary"  onClick={() => handleSave()} disabled={loadingSave}>
                    {loadingSave ? (
                        <>
                            <span className="spinner-border spinner-border-sm me-2" role="status"
                                  aria-hidden="true"></span>
                            Salvando...
                        </>
                    ) : (
                        <>
                            <i className="fa fa-save me-1"></i> Salvar Avaliação
                        </>
                    )}
                </Button>

            </Modal.Footer>
        </Modal>
    );
};

export default AccreditationCommentsModal;
